import React, { useState} from 'react'
import { Link } from 'react-router-dom'

import '../styles/succPage.css';
import { FaCheckCircle } from "react-icons/fa";

const SuccessPage = () => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
  return (
    <>
      <div className="SuccPage">
        <div className="succCont">
          <h2>Your transaction is being processed.</h2>
          <p><FaCheckCircle /></p>
          <h4>You'll be notified when it's delivered. Contact support via livechat for more enquiries or via email. </h4>
          <div className="succLinks">
            <h3><Link to={`/${user?.result?.userName}/liveTrade`}> Live Trade </Link></h3>
            <h3><Link to={`/${user?.result?.userName}/dashboard`}> Dashboard </Link></h3>
          </div>
        </div>
      </div>
    </>
  )
}

export default SuccessPage